import { InfoWorkType, WorkType } from '@kanda-libs/ks-frontend-services';
import FinanceCalculatorProvider from './context';
import FinanceCalculatorForm from './Form';

export interface FinanceCalculatorProps {
  infoWorkTypes: InfoWorkType[] | undefined;
  workType: WorkType | undefined;
  isLoading?: boolean;
  initialValue?: number;
}

const FinanceCalculator: React.FunctionComponent<FinanceCalculatorProps> =
  function (props) {
    return (
      <FinanceCalculatorProvider {...props}>
        <FinanceCalculatorForm />
      </FinanceCalculatorProvider>
    );
  };

export default FinanceCalculator;
